import { render } from "./Webhooks.vue?vue&type=template&id=2f8f469f"
import script from "./Webhooks.vue?vue&type=script&lang=js"
export * from "./Webhooks.vue?vue&type=script&lang=js"

import "./Webhooks.vue?vue&type=style&index=0&id=2f8f469f&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__